import React from "react";
import PageLayout from "../PageLayout";

const Error404: React.FC = () => (
  <PageLayout header="404" message="Such page does not exist" />
);

export default Error404;
